import React from 'react'
import { Button, Confirm, Header, Form, Icon, input, Table, Checkbox } from 'semantic-ui-react'
import { inlineStyle } from '../../styles/custom'

const ksort = (obj) => {
  var keys = Object.keys(obj).sort()
    , sortedObj = {}

  for(var i in keys) {
    sortedObj[keys[i]] = obj[keys[i]]
  }

  return sortedObj
}

const isChecked = (permission, permissions) => {
  for (let _permission of permissions) {
    if (_permission.id === permission.id) {
      return true
    }
  }
  return false
}

const renderPermissions = (obj, permissions, onChange) => {
  let _permissionsByGroups = {}
  for (let permission of permissions) {
    if (!_permissionsByGroups[permission.group]) {
      _permissionsByGroups[permission.group] = []
    }

    _permissionsByGroups[permission.group].push({
      ...permission,
      type: permission.slug.replace(/(_[\w]+)/, '')
    })
  }

  _permissionsByGroups = ksort(_permissionsByGroups)

  let i = 1
  let rows = []
  const types = ['get', 'create', 'update', 'delete']
  for (let group in _permissionsByGroups) {
    let cells = {}
    const len = (_permissionsByGroups[group].length >= 4) ? 4 : _permissionsByGroups[group].length
    for (let j = 0; j < len; j++) {
      if (_permissionsByGroups[group][j]) {
        const permission = _permissionsByGroups[group][j]
        cells[permission.type] = (
          <Checkbox
            onChange={(e, data) => {onChange(e, permission)}}
            checked={isChecked(permission, obj.permissions)}
          />
        )
      } else {
        cells[types[j]] = null
      }
    }

    rows.push(
      <Table.Row key={`g${i}`}>
        <Table.Cell>{group}</Table.Cell>
        <Table.Cell textAlign='center'>{cells['get']}</Table.Cell>
        <Table.Cell textAlign='center'>{cells['create']}</Table.Cell>
        <Table.Cell textAlign='center'>{cells['update']}</Table.Cell>
        <Table.Cell textAlign='center'>{cells['delete']}</Table.Cell>
      </Table.Row>
    )

    i++
  }

  return (
    <Table compact celled definition>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Entité</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Lire</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Créer</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Modifier</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Supprimer</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {rows}
      </Table.Body>
    </Table>
  )
}

const RoleForm = ({obj, permissions, status, onChange, onSubmit, onDelete}) => {
  return (
    <Form>
      <Header>Rôle{status.isNew ? ' : Création' : ' : Édition'}</Header>
      <Form.Field>
        <label>Libellé</label>
        <input placeholder="Libellé du rôle" id="name" value={obj.name} onChange={onChange}/>
      </Form.Field>
      <Form.Field>
        <label>Description</label>
        <input placeholder="description" id="description" value={obj.description} onChange={onChange}/>
      </Form.Field>
      <Form.Group grouped>
        <label>Permissions</label>
        {
          permissions.loading ? <div>Chargement</div> :
            renderPermissions(obj, permissions.getPermissions, onChange)
        }
      </Form.Group>
      <Form.Field>
        {status.loading ? <Button type='submit' floated='left' color='red' loading> Chargement...</Button> :
          <Button type='submit' floated='left' color='olive' onClick={onSubmit}><Icon name="save"/> Sauvegarder</Button>
        }
        {!status.isNew ? (
          <div>
            <Button type='submit' color='red' floated='right' onClick={(event, data) => { onDelete(event, {confirm: true}) }}><Icon name="delete"/> Suppression</Button>
          </div>
        ) : null}
      </Form.Field>
      <Confirm
        content='Êtes-vous sûr(e) de vouloir supprimer ce rôle ? Cette action est définitive.'
        open={status.deletion.confirm} onCancel={(event, data) => { onDelete(event, {confirm: null}) }}
        onConfirm={(event, data) => { onDelete(event, {confirm: false}) }} style={inlineStyle.modal}
        cancelButton='Annuler'
        confirmButton='Ok'
      />
    </Form>
  )
}

export default RoleForm




// WEBPACK FOOTER //
// ./src/components/form/Role.js